import ApplePodcastsIcon from './ApplePodcastsIcon';
import GooglePodcastsIcon from './GooglePodcastsIcon';
import RssIcon from './RssIcon';
import SoundCloudIcon from './SoundCloudIcon';
import SpotifyIcon from './SpotifyIcon';
import StitcherIcon from './StitcherIcon';

import { PodcastServiceType } from '@wix/podcasts-common/dist/settings/constants';

const ICONS = {
  [PodcastServiceType.RSS]: RssIcon,
  [PodcastServiceType.APPLE]: ApplePodcastsIcon,
  [PodcastServiceType.GOOGLE]: GooglePodcastsIcon,
  [PodcastServiceType.SOUND_CLOUD]: SoundCloudIcon,
  [PodcastServiceType.SPOTIFY]: SpotifyIcon,
  [PodcastServiceType.STITCHER]: StitcherIcon,
};

export default ICONS;
